import React from "react";
import FormSignup from "../components/Forms/FormSignup";

const Signup = (props) => {
  return <FormSignup />;
};

export default Signup;
